__turbopack_context__.v({
  "code": "DemoLiveContent-module__MI7Zpq__code",
  "codeBlock": "DemoLiveContent-module__MI7Zpq__codeBlock",
  "codeSection": "DemoLiveContent-module__MI7Zpq__codeSection",
  "container": "DemoLiveContent-module__MI7Zpq__container",
  "demoSection": "DemoLiveContent-module__MI7Zpq__demoSection",
  "demoSurface": "DemoLiveContent-module__MI7Zpq__demoSurface",
  "header": "DemoLiveContent-module__MI7Zpq__header",
  "headerActions": "DemoLiveContent-module__MI7Zpq__headerActions",
  "headerContainer": "DemoLiveContent-module__MI7Zpq__headerContainer",
  "resetButton": "DemoLiveContent-module__MI7Zpq__resetButton",
  "switchContainer": "DemoLiveContent-module__MI7Zpq__switchContainer",
  "switchContainerHidden": "DemoLiveContent-module__MI7Zpq__switchContainerHidden",
  "tabContainer": "DemoLiveContent-module__MI7Zpq__tabContainer",
});
